import registrationReducer from "./registrationSlice";

export default registrationReducer;
